import React from "react"
import { Toggle } from "material-ui"
import { ILeaveTrackingStateFilter, IDateRange, EDayOfWeek, ETimeoffStatus } from "../../models"
import strings from "../../localization/strings"
import TimeActionBar from "../common/TimeActionBar/TimeActionBar"
import * as leaveRequestHelper from "../../helpers/leaveRequestHelper"
interface IProps {
  referenceDate: Date | string
  stateFilter: ILeaveTrackingStateFilter
  handleUpdateStateFilter(stateFilter: ILeaveTrackingStateFilter): void
  handleUpdateDateFilter(dateFilter: IDateRange): void
}

const LeaveTrackingFilterForCalendarView: React.SFC<IProps> = (props: IProps) => {
  const handleUpdateStateFilter = (e, value) => {
    const payload = Object.assign({}, props.stateFilter)
    payload[e.target.name] = value
    props.handleUpdateStateFilter(payload)
  }
  if (document.getElementById("TimeActionBar")) {
    document.getElementById("TimeActionBarDate").style.width = "115px"
    document.getElementById("TimeActionBarDateArrow").style.width = "150px"
    document.getElementById("TimeActionBar").style.width = "620px"
  }

  return (
    <div style={{ padding: "0px 35px 0px 35px", display: "flex", marginTop: -10, justifyContent: "space-between" }}>
      <div style={{ width: 400, paddingTop: 25 }}>
        <div style={{ display: "inline-block", position: "relative" }}>
          <Toggle
            data-intercom-target={"LeaveTracking-FilterCalendar-Toggle-Requested"}
            name="Requested"
            toggled={props.stateFilter.Requested}
            label={strings.Requested}
            onToggle={handleUpdateStateFilter}
            style={{ width: 105, display: "inline-block", marginRight: 20, marginLeft: 25 }}
          />
          <div style={{ display: "inline-block", backgroundColor: leaveRequestHelper.getColor500ByTimeoffStatus(ETimeoffStatus.Requested), width: 20, height: 20, borderRadius: 10, position: "absolute", left: 0 }} />
        </div>
        <div style={{ display: "inline-block", position: "relative" }}>
          <Toggle
            data-intercom-target={"LeaveTracking-FilterCalendar-Toggle-Approved"}
            name="Approved"
            toggled={props.stateFilter.Approved}
            label={strings.Approved}
            onToggle={handleUpdateStateFilter}
            style={{ width: 97, display: "inline-block", marginRight: 20, marginLeft: 25 }}
          />
          <div style={{ display: "inline-block", backgroundColor: leaveRequestHelper.getColor500ByTimeoffStatus(ETimeoffStatus.Approved), width: 20, height: 20, borderRadius: 10, position: "absolute", left: 0 }} />
        </div>
        <div style={{ display: "inline-block", position: "relative" }}>
          <Toggle
            data-intercom-target={"LeaveTracking-FilterCalendar-Toggle-Denied"}
            name="Denied"
            toggled={props.stateFilter.Denied}
            label={strings.Denied}
            onToggle={handleUpdateStateFilter}
            style={{ width: 83, display: "inline-block", marginLeft: 25 }}
          />
          <div style={{ display: "inline-block", backgroundColor: leaveRequestHelper.getColor500ByTimeoffStatus(ETimeoffStatus.Denied), width: 20, height: 20, borderRadius: 10, position: "absolute", left: 0 }} />
        </div>
      </div>
      <div>
        <TimeActionBar
          referenceDate={props.referenceDate}
          handleChangeTimeRange={(StartDate, EndDate) => props.handleUpdateDateFilter({ StartDate, EndDate })}
          startDayOfWeek={EDayOfWeek.Monday}
          timeBarViewType="month"
        />
      </div>
    </div>
  )
}

export default LeaveTrackingFilterForCalendarView